import { ErrorHandler, Injectable, Injector } from "@angular/core";
import { MzModalService } from "ng2-materialize";
import { AgirErrorDialogComponent } from "../agir-error-dialog/agir-error-dialog.component";
import { HttpErrorResponse } from "@angular/common/http";
import { LicenseExpiredDialogComponent } from "../license-expired-dialog/license-expired-dialog.component";
import { SessionService } from "../../services/session/session.service";
import { Router } from "@angular/router";

@Injectable()
export class AgirErrorHandler extends ErrorHandler {
  private fired: boolean;

  constructor(
    private injector: Injector,
    private sessionService: SessionService
  ) {
    super();
  }

  handleError(error) {
    super.handleError(error);
    if (!this.fired) {
      if (error.rejection) error = error.rejection;

      if (error instanceof HttpErrorResponse) {
        this.fired = true;
        if (error.status === 402) {
          this.injector
            .get(MzModalService)
            .open(LicenseExpiredDialogComponent)
            .instance.modalComponent.onClose.subscribe(
              (_) => (this.fired = false)
            );
        } else if (error.status === 401) {
          this.sessionService.destroy();
          this.injector.get(Router).navigateByUrl("/login");
        } else if (error.status === 404) {
          this.injector.get(Router).navigateByUrl("/404");
        } else if (error.status === 403) {
          this.injector.get(Router).navigateByUrl("/403");
        } else {
          this.injector
            .get(MzModalService)
            .open(AgirErrorDialogComponent)
            .instance.modalComponent.onClose.subscribe(
              (_) => (this.fired = false)
            );
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/agir-error-handler/agir-error-handler.component.ts